// @greenlight-spec: 29-app-environment-variables.md
// @greenlight-spec: 16-api-conventions.md
import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { EnvContractResponseSchema, EnvListQuerySchema, EnvRemoveResponseSchema, EnvSetResponseSchema, RemoveEnvVarBodySchema, SetEnvVarBodySchema, } from '@greenlight/shared';
import { AppIdParamsSchema, errorResponses } from './common.js';
const c = initContract();
const EnvNameParamsSchema = AppIdParamsSchema.extend({
    name: z.string().min(1).max(128),
});
export const envContract = c.router({
    list: {
        method: 'GET',
        path: '/api/apps/:id/env',
        pathParams: AppIdParamsSchema,
        // `reveal=true` returns plain (non-sensitive) values on demand. Sensitive and
        // managed values are never returned (docs/29 AC-ENV-03). The REST shape is the
        // same `{ user, managed }` split the MCP `envList` tool returns.
        query: EnvListQuerySchema,
        responses: {
            200: EnvContractResponseSchema,
            ...errorResponses,
        },
        summary: 'List the env contract: declared user names (with vault presence) + managed names.',
    },
    set: {
        method: 'POST',
        path: '/api/apps/:id/env',
        pathParams: AppIdParamsSchema,
        body: SetEnvVarBodySchema,
        responses: { 200: EnvSetResponseSchema, ...errorResponses },
        summary: 'Set or update a user-controlled env-var value (written to vault).',
    },
    remove: {
        method: 'DELETE',
        path: '/api/apps/:id/env/:name',
        pathParams: EnvNameParamsSchema,
        body: RemoveEnvVarBodySchema,
        responses: { 200: EnvRemoveResponseSchema, ...errorResponses },
        summary: 'Remove a user-controlled env-var (vault + metadata row).',
    },
});
//# sourceMappingURL=env.js.map